import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_ever_wheld_or_threatened_to_whold_or_delayed_wage_p'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_ever_wheld_or_threatened_to_whold_or_delayed_wage_p',
  name: 'Has the facility ever withheld - or threatened to withhold - or delayed wage payments in order to keep workers at the facility?',
  description:
    'The intent of this question is to understand if the facility has ever delayed or withheld wage payments in order to coerce workers to work. For example, employers may delay wage payments in order to coerce workers to stay on the job, or they may exact unpaid work by withholding workers\' wages prior to terminating them. If the problem only concerns irregular payments and does not involve coercion, it should be addressed as a wage issue, not as forced labor.\r\r\n\r\r\n"Withheld" refers to retaining or keeping salaries owed to workers.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-14',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17760,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
